import '@stackflow/plugin-basic-ui/index.css';
import AppToaster from '@components/AppToaster';
import BottomSheets from '@components/BottomSheets';
import CheckingService from '@components/CheckingService';
import ErrorBoundary from '@components/ErrorBoundary';
import GlobalModal from '@components/GlobalModal';
import GlobalLoader from '@components/Loading/GlobalLoader';
import AppProvider from '@providers/AppProvider';
import { linkUrlResolver, Stack } from '@router/stackflow';
import { LinkUrlResolverProvider } from '@stackflow/link';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import '@locales/i18n';
import '@styles/index.scss';
import 'mapbox-gl/dist/mapbox-gl.css';
// @ts-ignore
import 'swiper/css';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Seoul');

function App() {
    return (
        <AppProvider>
            <LinkUrlResolverProvider resolver={linkUrlResolver}>
                <ErrorBoundary>
                    <Stack/>
                    <AppToaster/>
                    <GlobalLoader/>
                    <GlobalModal/>
                    <BottomSheets/>
                    <CheckingService/>
                </ErrorBoundary>
            </LinkUrlResolverProvider>
        </AppProvider>
    );
}

export default App;
